import { API_ROOT } from '../../config/config'
import { doDelete, doDownload, doGet, doPost, doPostDownload, doPostFiles } from './utils'

// const API_ROOT = 'http://localhost:9014/api'

export const getSubprojectMain = (projectCode, pageNum, pageSize) => {
  const url = `${API_ROOT}/v1/accounting/subproject/main/${projectCode}?pageNum=${
    pageNum || 0
  }&pageSize=${pageSize || 0}`
  return doGet(url)
}
export const searchSubproject = (request, projectCode, pageNum, pageSize) => {
  const url = `${API_ROOT}/v1/accounting/subproject/search-subproject/${projectCode}?pageNum=${
    pageNum || 0
  }&pageSize=${pageSize || 0}`
  return doPost(url, request)
}

export const getSubprojectPeriodInfo = (subProjectCode) => {
  const url = `${API_ROOT}/v1/accounting/subproject/period-info/${subProjectCode}`
  return doGet(url)
}

export const getSubprojectIncomExpensesList = (subProjectCode, period) => {
  const url = `${API_ROOT}/v1/accounting/subproject/incom-expenses-list/${subProjectCode}/${period}`
  return doGet(url)
}

export const searchSubprojectIncomExpensesList = (
  request,
  subProjectCode,
  period,
  pageNum,
  pageSize
) => {
  const url = `${API_ROOT}/v1/accounting/subproject/search-incom-expenses-list/${subProjectCode}/${period}?pageNum=${
    pageNum || 0
  }&pageSize=${pageSize || 0}`
  return doPost(url, request)
}

export const getSubprojectExpenses = (projectCode, period, id) => {
  const url = `${API_ROOT}/v1/accounting/subproject/expenses/${projectCode}/${period}?id=${
    id || ''
  }`
  return doGet(url)
}

export const saveSubprojectExpenses = (request) => {
  const url = `${API_ROOT}/v1/accounting/expenses/save`
  return doPost(url, request)
}

export const getSubprojectExpensesAttachments = (fileId) => {
  const url = `${API_ROOT}/v1/accounting/expenses/attachments/${fileId}`
  return doDownload(url)
}

export const deleteSubprojectExpenses = (id) => {
  const url = `${API_ROOT}/v1/accounting/expenses/${id}`
  return doDelete(url)
}
